import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs/observable/of';

/**
  Fork an epic to use inside another one
  @function forkEpic
  @param {Object} epicFactory Epic to apply
  @param {Object} store Redux store
  @param {List} actions List of actions to emit to the epic
  @returns {Observable}
*/
export const forkEpic = (epicFactory, store, ...actions) => {
  const input$ = of(...actions);
  const actions$ = new ActionsObservable(input$);
  return epicFactory(actions$, store);
};



// WEBPACK FOOTER //
// ./src/utils/epics/forkEpic.js